import { Children, cloneElement, FC, PropsWithChildren, ReactElement } from 'react';
import { PiiRoles } from '../../analytics/dataMasking';

interface Props extends PropsWithChildren {}

/**
 * Children of this component should be a PrimeReact input component that accept setting
 * HTML attributes on their internal HTMLInputElement via the pt prop
 */
export const MaskedInput: FC<Props> = ({ children }) => {
  const element = Children.only(children);
  const inputElement = cloneElement(element as ReactElement, {
    pt: {
      root: { 'data-pii-role': PiiRoles.Student },
      input: { 'data-pii-role': PiiRoles.Student },
      filterInput: { root: { 'data-pii-role': PiiRoles.Student } },
    },
  });

  return inputElement;
};
